import { createSelector } from '@reduxjs/toolkit';
import { selectBuildingType, selectOfficeTypes } from 'shared/selectors/jsonQuery';
import { EBuildingType } from '../../../../packages/JsonQuery/types/buildingType';
import { getBuildingTypeFields } from '../../../../packages/JsonQuery/utils/getBuildingTypeFields';

const LABELS: Record<EBuildingType, string> = {
  [EBuildingType.BusinessCenter]: 'Бизнес-центр',
  [EBuildingType.House]: 'Особняк',
  [EBuildingType.AdministrativeBuilding]: 'Административное здание',
  [EBuildingType.MultifunctionalComplex]: 'Многофункциональный комплекс',
  [EBuildingType.Warehouse]: 'Склад или логистический центр',
  [EBuildingType.FAO]: 'Помещение свободного назначения',
  [EBuildingType.Other]: 'Прочее',
  [EBuildingType.ShoppingCenter]: 'Площадь в торговом центре',
  [EBuildingType.ResidentialBuilding]: 'Жилое здание',
  [EBuildingType.OfficeBuilding]: 'Офисное здание',
};

export const selectBuildingTypeFilter = createSelector(
  [selectBuildingType, selectOfficeTypes],
  (value, officeTypes) => ({
    label: 'Тип здания',
    options: getBuildingTypeFields(officeTypes).map(field => ({ label: LABELS[field], value: field })),
    value: value && value.length > 0 ? value : [null],
  }),
);
